import { render } from "./DeliveriesTab.vue?vue&type=template&id=7fd69b06&scoped=true"
import script from "./DeliveriesTab.vue?vue&type=script&lang=js"
export * from "./DeliveriesTab.vue?vue&type=script&lang=js"

import "./DeliveriesTab.vue?vue&type=style&index=0&id=7fd69b06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd69b06"]])

export default __exports__